import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/showSmnCaPpageBanner/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSmnCaPpageBannerSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showSmnCaPpageBannerSelector };
